export class ReconciliationOrderDto {
  payments: number;
  applicationSourceId: number;
  posDeviceId: number;
  posDeviceTypeId: number;
  posDeviceIsVirtual: boolean;
  reportName: string;
  merchantId: number;
  merchantName: string;
  merchantMainCurrencyId: number;
  settledAmount: number;
  discountAmount: number;
  serviceChargeAmount: number;
  deliveryFee: number;
  processingFee: number;
  fxCurrencyAmount: number;
  paidCurrencyId: number;
  paidCurrencySymbol: string;
  paidCurrencyCode: string;
  paymentType: string;
  paymentMethodId: boolean;
  isCard: number;
  isCash: number;
  isIntegration: number;
  isOtherPayment: number;
  isDepositPayment: number;
  paymentProcessingFee: number;
  eodReport: string;
  merchantPaymentTypes: string;
}
